(() => {
  function initCollectionExperience(root) {
    if (root.dataset.tradeReady === 'v3') return;
    root.dataset.tradeReady = 'v3';

    const filters = root.querySelector('[data-ezcx-filters]');
    root.querySelector('[data-ezcx-filter-open]')?.addEventListener('click', () => filters?.classList.add('is-open'));
    root.querySelector('[data-ezcx-filter-close]')?.addEventListener('click', () => filters?.classList.remove('is-open'));

    root.querySelectorAll('[data-ezcx-view]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-ezcx-view]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        const grid = root.querySelector('[data-ezcx-grid]');
        if (grid) grid.dataset.columns = button.dataset.ezcxView;
      });
    });

    const browseView = root.querySelector('[data-trade-browse-view]');
    const tradeView = root.querySelector('[data-trade-view]');
    const modeButtons = [...root.querySelectorAll('[data-trade-mode-button]')];
    const dock = root.querySelector('[data-trade-dock]');
    const rows = [...root.querySelectorAll('[data-trade-row]')];
    const products = [...root.querySelectorAll('[data-trade-product]')];
    const search = root.querySelector('[data-trade-search]');
    const skuJump = root.querySelector('[data-trade-sku-jump]');
    const skuGo = root.querySelector('[data-trade-sku-go]');
    const stockOnly = root.querySelector('[data-trade-stock-only]');
    const visibleCount = root.querySelector('[data-trade-visible-count]');
    const countNode = root.querySelector('[data-trade-count]');
    const lineNode = root.querySelector('[data-trade-lines]');
    const totalNode = root.querySelector('[data-trade-total]');
    const shippingNode = root.querySelector('[data-trade-shipping]');
    const addAll = root.querySelector('[data-trade-add-all]');
    const clearAll = root.querySelector('[data-trade-clear]');
    const saveList = root.querySelector('[data-trade-save-list]');
    const threshold = Number(root.dataset.tradeShippingThreshold || 0);
    const collectionKey = location.pathname.replace(/\/+$/, '') || 'collection';
    const draftKey = `studioos-trade-draft-v3:${collectionKey}`;
    const restockKey = 'studioos-restock-lists-v1';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
      style:'currency', currency:'GBP'
    });
    const rootRoute = window.Shopify?.routes?.root || '/';

    const safeJSON = (key, fallback) => {
      try {
        const value = JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback));
        return value ?? fallback;
      } catch {
        return fallback;
      }
    };

    const normaliseText = (value = '') =>
      String(value).toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

    const groupName = (source = '') => {
      const text = normaliseText(source);
      if (/\b(pm[u]?)\b|permanent makeup/.test(text)) return 'PMU';
      if (/\b(rm|cm|sem)\b|curved mag|soft edge|round mag/.test(text)) return 'Curved Magnums';
      if (/\b(m1|mg)\b|weaved mag|magnum/.test(text)) return 'Magnums';
      if (/\b(rs)\b|round shader/.test(text)) return 'Round Shaders';
      if (/\b(rl)\b|round liner|fine line/.test(text)) return 'Round Liners';
      if (/bug\s*pin|bugpin/.test(text)) return 'Bugpin';
      return 'Other Configurations';
    };

    const normalise = (input) => {
      const parsed = Math.floor(Number(input.value));
      const value = Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
      input.value = String(value);
      return value;
    };

    const rowData = (row) => {
      const input = row.querySelector('[data-trade-qty]');
      const name =
        row.querySelector('.sos-trade-row__name strong')?.textContent?.trim() ||
        row.querySelector('.sos-trade-product__identity h3')?.textContent?.trim() ||
        'Product';
      const image = row.querySelector('img')?.currentSrc || row.querySelector('img')?.src || '';
      return {
        id: Number(row.dataset.variantId),
        quantity: input ? normalise(input) : 0,
        price: Number(row.dataset.price || 0),
        available: row.dataset.available === 'true',
        title: name,
        image,
        url: row.querySelector('a')?.href || '',
        sku: row.querySelector('.sos-trade-row__name small')?.textContent?.replace(/^SKU\s*/i, '').trim() || '',
        row
      };
    };

    const selected = () => rows.map(rowData).filter((item) => item.quantity > 0 && item.available);

    const saveDraft = () => {
      try {
        const draft = selected().reduce((map, item) => {
          map[item.id] = item.quantity;
          return map;
        }, {});
        if (Object.keys(draft).length) localStorage.setItem(draftKey, JSON.stringify(draft));
        else localStorage.removeItem(draftKey);
      } catch {}
    };

    const restoreDraft = () => {
      const draft = safeJSON(draftKey, {});
      rows.forEach((row) => {
        const input = row.querySelector('[data-trade-qty]');
        const value = draft[String(row.dataset.variantId)] ?? draft[row.dataset.variantId];
        if (input && Number(value) > 0 && row.dataset.available === 'true') {
          input.value = String(Math.floor(Number(value)));
        }
      });
    };

    const buildGroups = () => {
      const container = root.querySelector('[data-trade-terminal]');
      if (!container) return;

      const groups = new Map();
      rows.forEach((row) => {
        const name = groupName(row.dataset.groupSource || row.dataset.search || '');
        if (!groups.has(name)) groups.set(name, []);
        groups.get(name).push(row);
      });

      const order = ['Round Liners','Round Shaders','Magnums','Curved Magnums','Bugpin','PMU','Other Configurations'];
      order.forEach((name) => {
        const groupRows = groups.get(name);
        if (!groupRows?.length) return;

        const heading = document.createElement('div');
        heading.className = 'sos-trade-group';
        heading.dataset.tradeGroup = name;
        heading.innerHTML = `<span>${name}</span><b>${groupRows.length} variants</b>`;
        container.appendChild(heading);

        groupRows.forEach((row) => {
          const product = row.closest('[data-trade-product]');
          if (product?.classList.contains('sos-trade-product--single')) {
            container.appendChild(product);
          } else {
            container.appendChild(row);
          }
        });
      });

      products.forEach((product) => {
        if (!product.children.length || product.querySelectorAll('[data-trade-row]').length === 0) product.remove();
      });
    };

    const getVisibleInputs = () =>
      rows
        .filter((row) => !row.hidden && !row.closest('[hidden]') && row.dataset.available === 'true')
        .map((row) => row.querySelector('[data-trade-qty]'))
        .filter(Boolean);

    const focusByOffset = (input, offset) => {
      const inputs = getVisibleInputs();
      const index = inputs.indexOf(input);
      const target = inputs[index + offset];
      if (!target) return;
      target.focus();
      target.select();
      target.scrollIntoView({behavior:'smooth', block:'center'});
    };

    const updateSummary = ({persist = true} = {}) => {
      if (!dock) return;
      const items = selected();
      const count = items.reduce((sum, item) => sum + item.quantity, 0);
      const lines = items.length;
      const total = items.reduce((sum, item) => sum + item.price * item.quantity, 0);

      if (countNode) countNode.textContent = String(count);
      if (lineNode) lineNode.textContent = String(lines);
      if (totalNode) totalNode.textContent = money.format(total / 100);
      if (shippingNode) {
        const remaining = Math.max(0, threshold - total);
        shippingNode.textContent = threshold
          ? (remaining > 0 ? `${money.format(remaining / 100)} to free shipping` : 'Free shipping unlocked ✓')
          : '';
      }

      [addAll, clearAll, saveList].forEach((button) => {
        if (button) button.disabled = count === 0;
      });

      if (addAll) addAll.textContent = count ? `Add ${count} items to bag` : 'Add selected to bag';

      dock.classList.toggle('is-visible', root.classList.contains('is-trade-mode') && count > 0);
      rows.forEach((row) => row.classList.toggle('has-quantity', Number(row.querySelector('[data-trade-qty]')?.value || 0) > 0));

      if (persist) saveDraft();
    };

    const setMode = (mode, remember = true) => {
      const trade = mode === 'trade' && tradeView;
      root.classList.toggle('is-trade-mode', Boolean(trade));
      if (browseView) browseView.hidden = Boolean(trade);
      if (tradeView) tradeView.hidden = !trade;

      modeButtons.forEach((button) => {
        const active = button.dataset.tradeModeButton === (trade ? 'trade' : 'browse');
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (!trade) dock?.classList.remove('is-visible');
      if (remember) {
        try { localStorage.setItem('studioos-collection-mode', trade ? 'trade' : 'browse'); } catch {}
      }
      updateSummary({persist:false});
    };

    modeButtons.forEach((button) => button.addEventListener('click', () => setMode(button.dataset.tradeModeButton)));

    rows.forEach((row) => {
      const input = row.querySelector('[data-trade-qty]');

      row.querySelector('[data-trade-minus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = String(Math.max(0, normalise(input) - 1));
        updateSummary();
      });

      row.querySelector('[data-trade-plus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = String(normalise(input) + 1);
        updateSummary();
      });

      row.querySelectorAll('[data-trade-add]').forEach((button) =>
        button.addEventListener('click', () => {
          if (!input) return;
          input.value = String(normalise(input) + Number(button.dataset.tradeAdd || 0));
          updateSummary();
        })
      );

      input?.addEventListener('input', () => {
        input.value = input.value.replace(/[^0-9]/g, '');
        updateSummary();
      });

      input?.addEventListener('blur', () => {
        normalise(input);
        updateSummary();
      });

      input?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === 'ArrowDown') {
          event.preventDefault();
          normalise(input);
          updateSummary();
          focusByOffset(input, 1);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          normalise(input);
          updateSummary();
          focusByOffset(input, -1);
        }
      });
    });

    const syncGroupVisibility = () => {
      root.querySelectorAll('[data-trade-group]').forEach((group) => {
        let next = group.nextElementSibling;
        let hasVisible = false;
        while (next && !next.matches('[data-trade-group]')) {
          if ((next.matches('[data-trade-row]') || next.matches('[data-trade-product]')) && !next.hidden) {
            hasVisible = true;
          }
          next = next.nextElementSibling;
        }
        group.hidden = !hasVisible;
      });
    };

    const filterRows = () => {
      const query = normaliseText(search?.value || '');
      const onlyStock = Boolean(stockOnly?.checked);
      let shown = 0;

      rows.forEach((row) => {
        const show =
          (!query || normaliseText(row.dataset.search || '').includes(query)) &&
          (!onlyStock || row.dataset.available === 'true');

        row.hidden = !show;
        const product = row.closest('[data-trade-product]');
        if (product?.classList.contains('sos-trade-product--single')) product.hidden = !show;
        if (show) shown += 1;
      });

      syncGroupVisibility();
      if (visibleCount) visibleCount.textContent = `${shown} variant${shown === 1 ? '' : 's'}`;
    };

    let tradeFilterTimer;
    search?.addEventListener('input', () => {
      clearTimeout(tradeFilterTimer);
      tradeFilterTimer = setTimeout(filterRows, 80);
    });
    stockOnly?.addEventListener('change', filterRows);

    const jumpToSku = () => {
      const query = normaliseText(skuJump?.value || '');
      if (!query) return;

      const row = rows.find((item) => normaliseText(item.dataset.search || '').includes(query));
      if (!row) {
        toast(`No match found for ${skuJump.value}`);
        return;
      }

      row.hidden = false;
      const product = row.closest('[data-trade-product]');
      if (product) product.hidden = false;
      row.scrollIntoView({behavior:'smooth', block:'center'});
      row.classList.add('is-jump-highlight');
      setTimeout(() => row.classList.remove('is-jump-highlight'), 1400);

      const input = row.querySelector('[data-trade-qty]');
      input?.focus();
      input?.select();
    };

    skuGo?.addEventListener('click', jumpToSku);
    skuJump?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        jumpToSku();
      }
    });

    const toast = (message) => {
      let node = document.querySelector('.sos-trade-toast');
      if (!node) {
        node = document.createElement('div');
        node.className = 'sos-trade-toast';
        document.body.appendChild(node);
      }
      node.textContent = message;
      node.classList.add('is-visible');
      clearTimeout(node._timer);
      node._timer = setTimeout(() => node.classList.remove('is-visible'), 2800);
    };

    clearAll?.addEventListener('click', () => {
      rows.forEach((row) => {
        const input = row.querySelector('[data-trade-qty]');
        if (input) input.value = '0';
      });
      updateSummary();
      toast('Trade selection cleared');
    });

    saveList?.addEventListener('click', () => {
      const items = selected();
      if (!items.length) return;
      const suggested = `Trade order ${new Date().toLocaleDateString('en-GB')}`;
      const name = window.prompt('Name this restock list', suggested)?.trim();
      if (!name) return;

      const lists = safeJSON(restockKey, []);
      lists.unshift({
        id: `${Date.now()}`,
        name,
        items: items.map((item) => ({
          handle: `variant-${item.id}`,
          title: item.title,
          url: item.url,
          image: item.image,
          price: money.format(item.price / 100),
          variantId: String(item.id),
          quantity: item.quantity,
          sku: item.sku
        }))
      });

      try {
        localStorage.setItem(restockKey, JSON.stringify(lists));
        toast(`Saved “${name}” to Studio Dashboard`);
      } catch {
        toast('Unable to save the restock list on this device');
      }
    });

    addAll?.addEventListener('click', async () => {
      const items = selected().map(({id, quantity}) => ({id, quantity}));
      if (!items.length) return;

      const original = addAll.textContent;
      addAll.disabled = true;
      addAll.textContent = 'Adding order…';

      try {
        const response = await fetch(`${rootRoute}cart/add.js`, {
          method:'POST',
          headers:{Accept:'application/json','Content-Type':'application/json','Cache-Control':'no-cache'},
          credentials:'same-origin',
          cache:'no-store',
          body:JSON.stringify({items, sections:['ez-cart-drawer'], sections_url:`${rootRoute}cart`})
        });
        const payload = await response.json().catch(() => ({}));

        if (!response.ok) {
          throw new Error(payload.description || 'Trade order could not be added');
        }

        rows.forEach((row) => {
          const input = row.querySelector('[data-trade-qty]');
          if (input) input.value = '0';
        });

        updateSummary();
        localStorage.removeItem(draftKey);

        document.dispatchEvent(new CustomEvent('studioos:cart:refresh', {
          detail:{
            open:true,
            source:'trade-terminal',
            message:'Trade order added to your bag',
            sectionHtml:payload.sections?.['ez-cart-drawer'] || ''
          }
        }));

        toast(`${items.length} product lines added to your bag`);
      } catch (error) {
        toast(error.message || 'We could not add the trade order.');
      } finally {
        addAll.textContent = original;
        updateSummary({persist:false});
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        filters?.classList.remove('is-open');
        if (document.activeElement === search || document.activeElement === skuJump) {
          document.activeElement.value = '';
          filterRows();
        }
      }
    });

    buildGroups();
    restoreDraft();

    let remembered = 'browse';
    try { remembered = localStorage.getItem('studioos-collection-mode') || 'browse'; } catch {}

    setMode(remembered, false);
    filterRows();
    updateSummary({persist:false});
  }

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-ezcx]').forEach(initCollectionExperience);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), {once:true});
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
